<form
  [formGroup]="maintenanceForm"
  (ngSubmit)="onSubmit()"
  class="form-container"
>
  <span class="back">
    <
    <a (click)="cancelForm()" class="returnButton text-underline">
      {{ 'drone.maintenance-log.maintenance_log' | translate }}
    </a>
  </span>

  <!-- Part Info Section -->
  <h2 *ngIf="!maintenanceLog" class="section-title">
    {{ 'drone.maintenance-log.create' | translate }} {{ unitNumber }} -
    {{ airCraftName }}
  </h2>
  <h2 *ngIf="maintenanceLog" class="section-title">
    {{ 'drone.maintenance-log.edit' | translate }} {{ unitNumber }} -
    {{ airCraftName }}
  </h2>
  <h2 class="section-sub-title">
    {{ 'drone.maintenance-log.part_info' | translate }}
  </h2>
  <div class="form-row half-width">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'drone.maintenance-log.part' | translate }}</mat-label>
      <mat-select formControlName="part">
        <mat-option *ngFor="let part of partsList" [value]="part">
          {{ part.id }} - {{ part.partType | titleCaseReplace }} ({{
            part.partSubType | titleCaseReplace
          }})
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <h2 class="section-sub-title">
    {{ 'drone.maintenance-log.maintainer' | translate }}
  </h2>
  <div class="half-width">
    <app-autocomplete
      [data]="employees$"
      [label]="'drone.maintenance-log.search_employee' | translate"
      [isRequired]="true"
      [disabled]="!!maintenanceForm.get('maintainer')?.disabled"
      [preSelectedValue]="maintenanceForm.get('maintainer')?.value"
      propertyName="firstName"
      [formatterFn]="employeeNameFormatter"
      (valueSelected)="onMaintainerSelected($event)"
    ></app-autocomplete>
  </div>

  <!-- General Info Section -->
  <h2 class="section-sub-title">
    {{ 'drone.maintenance-log.general_info' | translate }}
  </h2>
  <div class="form-row">
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>{{
        'drone.maintenance-log.type_maintenance' | translate
      }}</mat-label>
      <mat-select formControlName="typeOfMaintenance">
        <mat-option *ngFor="let type of maintenanceTypes" [value]="type">{{
          type | titleCaseReplace
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>{{
      'drone.maintenance-log.short_description' | translate
    }}</mat-label>
    <input matInput formControlName="description" type="text" required />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{
      'drone.maintenance-log.long_description' | translate
    }}</mat-label>
    <textarea matInput formControlName="detailedDescription"></textarea>
  </mat-form-field>

  <!-- Attachments Section -->
  <h2 class="section-sub-title">
    {{ 'drone.maintenance-log.attachments' | translate }}
  </h2>
  <div class="form-row large-gap">
    <mat-card class="upload-options-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title
          >{{ 'drone.maintenance-log.add_file' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'drone.maintenance-log.add_file_msg' | translate }}</p>
      </mat-card-content>
      <mat-card-footer class="upload-options-card-footer">
        <app-file-upload
          #fileUploadComponent
          [inputLabel]="'drone.maintenance-log.select_file' | translate"
          [allowedFileTypes]="['application/zip', 'application/qsarchive']"
          [selectableFileTypes]="'.zip, .qsarchive'"
          (fileUploaded)="onFileSelected($event)"
        ></app-file-upload>
      </mat-card-footer>
    </mat-card>
    <span>
      <div *ngIf="maintenanceForm.get('attachments')?.value.length > 0">
        <h3>{{ 'drone.maintenance-log.attached' | translate }}</h3>
        <ul>
          <li
            *ngFor="let file of maintenanceForm.get('attachments')?.value"
            class="file-list-item"
          >
            <mat-icon>description</mat-icon> {{ file.name }} ({{
              (file.size / 1024).toFixed(2)
            }}
            KB)
            <mat-icon (click)="removeAttachment(file)" class="close"
              >close</mat-icon
            >
          </li>
        </ul>
      </div>
    </span>
  </div>

  <!-- Submit Button -->
  <div class="footer-line"></div>

  <div class="cancel-save-button-container">
    <a (click)="cancelForm()" class="cancelButton">
      {{ 'drone.maintenance-log.close' | translate }}
    </a>
    <app-button
      [disabled]="maintenanceForm.invalid"
      [tall]="true"
      [title]="'drone.maintenance-log.save' | translate"
      class="flex-position-end"
    >
    </app-button>
  </div>
</form>
